// extracted by mini-css-extract-plugin
export var container = "lpTwoColSection-module--container--889f5";
export var ctaContainer = "lpTwoColSection-module--ctaContainer--5e3ec";
export var ctaOffset = "lpTwoColSection-module--ctaOffset--589b7";
export var desktopImage = "lpTwoColSection-module--desktopImage--bb511";
export var heading = "lpTwoColSection-module--heading--4ab51";
export var imageContainer = "lpTwoColSection-module--imageContainer--282f5";
export var label = "lpTwoColSection-module--label--0d308";
export var mobileImage = "lpTwoColSection-module--mobileImage--82f6d";
export var playButton = "lpTwoColSection-module--playButton--2a1b8";
export var reverseOrder = "lpTwoColSection-module--reverseOrder--a9aa4";
export var smallerHeadline = "lpTwoColSection-module--smallerHeadline--87a20";
export var smallerSubheading = "lpTwoColSection-module--smallerSubheading--7692c";
export var subheading = "lpTwoColSection-module--subheading--08aa7";
export var textContainer = "lpTwoColSection-module--textContainer--3ceff";
export var usesMobileImage = "lpTwoColSection-module--usesMobileImage--9407a";
export var videoWrapper = "lpTwoColSection-module--videoWrapper--f3bd9";